<template>
  <section>
    <base-header>
      <div class="row align-items-center  pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">New Area</h1>
        </div>
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 text-right">
          <div class="box-buttons">
            <base-button type="primary" class="min-button" @click="saveAreas()">
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
          <div class="card ">
            <div class="row">
              <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                <WSelect
                  v-bind:class="{
                    'is-invalid': $v.area.branch.$error
                  }"
                  placeholder="Select Destination"
                  v-model="area.branch"
                  filterable
                  id="name_branch"
                  name="name_branch"
                  label="Destination"
                  markrequired
                  :error="$v.area.branch.$error ? `Select a Destination` : ''"
                >
                  <el-option
                    v-for="branch in branchesOptionsByOperatorId"
                    :value="branch._id"
                    :label="branch.name"
                    :key="branch._id"
                  ></el-option>
                </WSelect>
              </div>

              <div
                class="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12 mb-3"
                v-bind:class="{ 'is-invalid': $v.area.description.$error }"
              >
                <el-input
                  v-model="$v.area.description.$model"
                  placeholder="Description"
                  id="description"
                  name="description"
                  tabindex="2"
                  maxlength="160"
                  type="textarea"
                  :autosize="{ minRows: 1, maxRows: 5 }"
                  show-word-limit
                  label="Description"
                  markrequired
                >
                </el-input>
                <div
                  v-if="$v.area.description.$error"
                  class="invalid-feedback mt--1"
                >
                  {{
                    !$v.area.description.minLength || $v.area.description.$error
                      ? `Enter ${$v.area.description.$params.minLength.min} to ${$v.area.description.$params.maxLength.max} characters.`
                      : ""
                  }}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="card pb-4">
            <base-input
              id="autocomplete"
              label="Search Location"
              placeholder="Enter Location"
              v-model="search"
              class="abso-map-1"
            />
            <el-tooltip placement="bottom" content="Reset Area">
              <base-button
                type="outline-neutral"
                class="min-button btn-line-danger abso-map-3"
                @click="clearCoordinates"
              >
                <i class="flaticon-eraser"></i>Reset Area
              </base-button>
            </el-tooltip>

            <google-map
              @restartCoordinates="resetCoordinatesInTheMap"
              :reset="resetCoordinates"
              @getFullCoordinates="saveCoordinates"
              :coord="coordinates"
            ></google-map>
          </div>
        </div>
      </div>

      <div class="alinmov2 mb-4">
        <el-tooltip content="Back" placement="bottom">
          <base-button
            type="neutral"
            class="btn-icon-only"
            @click="goToPreviousPage()"
          >
            <i class="flaticon-left-1"></i>
          </base-button>
        </el-tooltip>

        <base-button
          type="primary"
          class="min-button mb-0"
          @click="saveAreas()"
        >
          <i class="flaticon-floppy-disk"></i>Save
        </base-button>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import GoogleMap from "../../Components/GoogleMap";
import endpoint from "../../Commons/Services/index";
import localHelper from "../Commons/Helper";
import WSelect from "@/components/Select";
import {
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  Checkbox,
  Switch,
  Card
} from "element-ui";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import Swal from "sweetalert2";
import lodash from "lodash";
import { goBack, unauthorizedAction } from "../../../helpers/commons.helpers";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "NewCoverageAreas",
  data() {
    return {
      area: {
        description: "",
        supplier: "",
        branch: "",
        polygon: [],
        relationship: {
          owner: null,
          type: "supplier"
        }
      },
      tempCoordinates: [],
      coordinates: [],
      resetCoordinates: false,
      search: null,
      loading: false,
      options: [],
      areaCopy: {},
      saved: false
    };
  },
  async created() {
    var bread = [
      {
        text: "Coverage Areas",
        to: "/coverage-areas"
      },

      {
        text: "New Coverage Area",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.area.supplier = this.$route.query.supplier
      ? this.$route.query.supplier
      : "";
    this.area.branch = this.$route.query.branch ? this.$route.query.branch : "";

    /**Clone service area*/
    this.area.supplier = this.getOwner(this.sesion);
    this.area.relationship.owner = this.getOwner(this.sesion);

    if (this.$route.query.duplicateArea) {
      await this.duplicateAreaService(this.$route.query.duplicateArea);
    }
    this.getBranchesOptionsByOperatorId(this.area.supplier);
    this.areaCopy = lodash.cloneDeep(this.area);
  },
  methods: {
    async saveAreas(router = null) {
      if (!this.$v.area.$invalid) {
        await this.createArea(this.area, router);
      } else {
        this.$v.area.$touch();
        this.$notify({
          type: "warning",
          title: "Important!",
          message: "Please complete the required attributes",
          icon: "flaticon-warning-1"
        });
      }
    },
    async createArea(area, router) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.areas.services.createArea(
          area,
          this.sesion.token
        );
        this.setLoad(false);
        this.saved = true;
        if (data.status) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The Coverage Area has been Saved",
            icon: "flaticon-check-3"
          });
          this.$router.push(router ? router : "/coverage-areas");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "There was an error saving the Coverage Area, please try again"
        );
      }
    },
    async duplicateAreaService(areaId) {
      try {
        this.setLoad(true);
        let { data } = await endpoint.areas.services.getAreaById(
          areaId,
          this.sesion.token
        );
        this.setLoad(false);
        if (data.status) {
          let area = data.data;
          this.area.description = area.description;
          this.area.polygon = this.parseCoordinates(area.polygon);
          this.coordinates = this.area.polygon;
          this.$notify({
            type: "info",
            title: "Duplicate Area!",
            message:
              "Your has been duplicated, please remember to add the destination.",
            icon: "flaticon-check-3"
          });
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.handleError(
          error,
          "The Operation could not be completed. Please try again"
        );
      }
    },
    resetCoordinatesInTheMap(status) {
      this.resetCoordinates = status;
    },
    saveCoordinates(coordinates) {
      this.tempCoordinates = coordinates;
      if (this.tempCoordinates.length > 0) {
        this.area.polygon = this.tempCoordinates;
      }
    },
    parseCoordinates(coordinates) {
      return coordinates.map(function(element) {
        return { lat: element.lat, lng: element.lng };
      });
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = unauthorizedAction(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    getOwner(sesion) {
      return sesion.role === sesion.account_type.type
        ? sesion.id
        : sesion.account_type.owner;
    },
    async clearCoordinates() {
      let { value } = await Swal.fire({
        title: "Reset marked area",
        text: "Are you sure do you want to reset the marked area ?",
        imageUrl: require("rhomtrip_assets/src/img/icons/alerts/question.png"),
        buttonsStyling: false,
        showCloseButton: true,
        showCancelButton: true,
        focusConfirm: false,
        reverseButtons: true,
        cancelButtonText: "No",

        confirmButtonText: "Yes",

        onClose: () => {
          setTimeout(() => {}, 1500);
        }
      });
      if (value) {
        this.resetCoordinates = true;
      }
    },
    async detectChanges(to, from, next) {
      if (!this.sigout) {
        let isEqual = lodash.isEqual(this.area, this.areaCopy);
        if (!isEqual && !this.saved) {
          let { value, dismiss } = await Swal.fire({
            title: "Important",
            html:
              "The Coverage Areas has been modified, <br> do you want to save changes?",
            imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
            buttonsStyling: false,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            reverseButtons: true,
            cancelButtonText: "No",

            confirmButtonText: "Yes",
            confirmButtonClass: "btn btn-primary btn-small-one"
          });
          if (value) {
            this.saveAreas(to.path);
          } else if (dismiss === Swal.DismissReason.cancel) {
            next();
          }
        } else {
          next();
        }
      } else {
        next();
      }
    },
    ...mapActions(["getBranchesOptionsByOperatorId"]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setItemsBread",
      "setAreasSearchCriteria"
    ])
  },
  components: {
    [Checkbox.name]: Checkbox,
    [Switch.name]: Switch,
    [Card.name]: Card,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    "google-map": GoogleMap,
    WSelect
  },
  computed: {
    ...mapGetters([
      "branchesOptionsByOperatorId",
      "sesion",
      "sigout",
      "areasSearchCriterial"
    ])
  },
  validations: {
    area: {
      description: {
        required,
        minLength: minLength(5),
        maxLength: maxLength(160)
      },
      supplier: {
        required
      },
      branch: {
        required
      },
      polygon: {
        $each: {
          lat: {},
          lng: {}
        }
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    localHelper.isInAreasModule(
      to.meta.modules,
      this.setAreasSearchCriteria,
      "areas"
    );
    this.detectChanges(to, from, next);
  }
};
</script>
